const MobilityEnum = Object.freeze({
    REGIONAL: "Regional",
    NATIONAL: "National",
    INTERNATIONAL: "International",
});

export default MobilityEnum;